import { people } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function PeopleArchive() {
  return (
    <section id="people" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHead
          kicker="PERSONA DOSSIER"
          title="人物深扒档案"
          note="按人物归档的深扒与旧账，一处看全"
          accent
        />
        <div className="grid grid-cols-2 gap-5 md:grid-cols-3 lg:grid-cols-6">
          {people.map((p) => (
            <article key={p.name} className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/60 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
              <div className="relative h-48 w-full overflow-hidden md:h-56">
                <img src={p.img} alt={`${p.name}深扒档案`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <span className={"absolute left-2 top-2 rounded px-1.5 py-0.5 text-[10px] font-bold text-foreground-50 " + (p.status === "热度上升" ? "bg-accent-500" : "bg-black/50")}>
                  {p.status}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-3">
                <a href="#archive" className="font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700">{p.name}</a>
                <p className="mt-1 text-xs text-foreground-500">{p.role}</p>
                <div className="mt-3 flex items-center justify-between border-t border-foreground-200/50 pt-2 text-[11px] text-foreground-600">
                  <span>{p.hits}</span>
                  <i className="ri-arrow-right-up-line transition-colors group-hover:text-primary-600" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}